module.exports = __webpack_public_path__ + "static/media/49.7b9ca645.png";